<template>
  <div>
    <template v-if="visibility('dashboard_access')">
      <div class="mt-2 mb-1 mx-4 text-green-300 text-xs">
        {{ $t('General') }}
      </div>
      <menu-item
        :label="$t('Dashboard')"
        :mobile="mobile"
        icon="font-awesome.tachometer-alt-regular"
        to="/admin/dashboard"
      ></menu-item>
    </template>

    <div class="my-2 mx-4 text-green-300 text-xs" v-if="groupVisibility(manageGates)">
      {{ $t('Managements') }}
    </div>
    <menu-item
      :label="$t('Sale orders')"
      :mobile="mobile"
      icon="font-awesome.cart-plus-solid"
      to="/admin/sale-orders"
      v-show="visibility('manage_sales')"
    ></menu-item>
    <menu-item
      :label="$t('Repair orders')"
      :mobile="mobile"
      icon="font-awesome.tools-solid"
      to="/admin/repairs"
      v-show="visibility('manage_repairs')"
    ></menu-item>
    <menu-item
      :label="$t('Custom products')"
      :mobile="mobile"
      icon="font-awesome.cart-arrow-down-solid"
      to="/admin/custom-products"
      v-show="visibility('manage_custom_products')"
    ></menu-item>

    <menu-item
      :label="$t('Custom bills')"
      :mobile="mobile"
      icon="font-awesome.file-signature-solid"
      to="/admin/custom-bills"
      v-show="visibility('manage_custom_bills')"
    ></menu-item>

    <div class="my-2 mx-4 text-green-300 text-xs" v-if="groupVisibility(resourceGates)">
      {{ $t('Resources') }}
    </div>
    <menu-item
      :label="$t('Categories')"
      :mobile="mobile"
      icon="font-awesome.sitemap-solid"
      to="/admin/categories"
      v-show="visibility('manage_categories')"
    ></menu-item>

    <menu-item
      :label="$t('Products')"
      :mobile="mobile"
      icon="font-awesome.th-list-solid"
      to="/admin/products"
      v-show="visibility('manage_products')"
    ></menu-item>
    <menu-item
      :label="$t('Warehouses')"
      :mobile="mobile"
      icon="font-awesome.warehouse-solid"
      to="/admin/warehouses"
      v-show="visibility('manage_warehouses')"
    ></menu-item>
    <menu-item
      :label="$t('Stocks')"
      :mobile="mobile"
      icon="font-awesome.tasks-regular"
      to="/admin/stocks"
      v-show="visibility('manage_stocks')"
    ></menu-item>
    <div class="my-2 mx-4 text-green-300 text-xs" v-if="groupVisibility(adminGates)">
      {{ $t('Administration') }}
    </div>
    <menu-item
      :label="$t('Users')"
      :mobile="mobile"
      icon="font-awesome.users-solid"
      to="/admin/users"
      v-show="visibility('manage_users')"
    ></menu-item>
    <menu-item
      :label="$t('User roles')"
      :mobile="mobile"
      icon="font-awesome.user-lock-solid"
      to="/admin/user-roles"
      v-show="visibility('manage_user_roles')"
    ></menu-item>

    <div class="my-2 mx-4 text-green-300 text-xs" v-if="groupVisibility(reportGates)">
      {{ $t('Reports') }}
    </div>
    <menu-item
    v-show="visibility('report')"
      :label="$t('Overall')"
      :mobile="mobile"
      icon="font-awesome.file-alt-regular"
      to="/admin/report"
    ></menu-item>
       <menu-item
    v-show="visibility('out_of_stock_alert')"
      :label="$t('Stock alerts')"
      :mobile="mobile"
      icon="font-awesome.exclamation-triangle-duotone"
      to="/admin/out-of-stock"
    ></menu-item>
    <div class="my-2 mx-4 text-green-300 text-xs" v-if="groupVisibility(toolGates) || groupVisibility(settingGates)">
      {{ $t('Tools') }}
    </div>
    <template v-if="groupVisibility(settingGates)">
      <menu-item
        :label="$t('Settings')"
        :mobile="mobile"
        icon="font-awesome.cogs-solid"
        to="/admin/settings"
      ></menu-item>
    </template>
    <menu-item
    v-show="visibility('print_label')"
      :label="$t('Label printing')"
      :mobile="mobile"
      icon="font-awesome.barcode"
      to="/print/product-label"
    ></menu-item>
    <menu-item
      :label="$t('Backup')"
      :mobile="mobile"
      icon="font-awesome.database-solid"
      to="/admin/backup"
      v-show="visibility('database_backup')"
    ></menu-item>
     <menu-item
      :label="$t('Translations')"
      :mobile="mobile"
      icon="font-awesome.globe-solid"
      to="/admin/languages"
      v-show="visibility('manage_translations')"
    ></menu-item>
  </div>
</template>
<script>
import { includes, forEach } from 'lodash';
import MenuItem from '@/components/layout/admin/menu/menu-item';
export default {
  name: 'menu-list',
  components: { MenuItem },
  props: {
    mobile: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      manageGates: ['manage_sales', 'manage_repairs', 'manage_custom_products', 'manage_custom_bills'],
      resourceGates: ['manage_categories', 'manage_products', 'manage_warehouses', 'manage_stocks'],
      adminGates: ['manage_users', 'manage_user_roles'],
      reportGates: ['report','out_of_stock_alert'],
      toolGates: ['database_backup', 'manage_translations','print_label'],
      settingGates: [
        'general_configuration',
        'appearance_configuration',
        'localization_configuration',
        'authentication_configuration',
        'outgoing_mail_configuration',
        'captcha_configuration',
        'currency_configuration',
        'tax_configuration',
        'terms_configuration',
        'printer_configuration',
        'pos_configuration',
      ],
    };
  },
  computed: {
    permissions() {
      return this.$store.getters['app/getPermissions'];
    },
    user() {
      return this.$store.getters['app/getUser'];
    },
  },
  methods: {
    visibility(key) {
      if (this.user.role_id < 2) {
        return true;
      }
      return includes(this.permissions, key);
    },
    groupVisibility(keys) {
      if (this.user.role_id < 2) {
        return true;
      }
      let permit = false;
      forEach(keys, (key) => {
        if (includes(this.permissions, key)) {
          permit = true;
        }
      });
      return permit;
    },
  },
};
</script>
